/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";

interface Props {
  idUsuarioLider: string;
}
export function useUsuariosPorEquipe(props: Props) {
  const LISTAR_USUARIOS_POR_EQUIPE = `identity/usuario/v2/listar-usuarios-por-equipe?idUsuarioLider=${props.idUsuarioLider}`;
  const fetchData = async () => {
    const response = await instance.get(LISTAR_USUARIOS_POR_EQUIPE);
    return response?.data?.data;
  };
  const query = useQuery({
    queryFn: fetchData,
    queryKey: ["listar-usuarios-por-equipe"],
    refetchOnWindowFocus: false,
    enabled: false,
    // refetchInterval: 60000,
    retry: false,
    onError: (error: any) => {
      toast?.error(
        `Erro ao listar usuarios. Motivos:\n ${error.response.data.notifications?.map(
          (item: any) => `${item?.message}`
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
